// extracted by mini-css-extract-plugin
export var spin = "tag-module--spin--e9e57";
export var tag = "tag-module--tag--c446d";
export var tag__active = "tag-module--tag__active--8b800";
export var tag__black = "tag-module--tag__black--3c824";
export var tag__bloodorange = "tag-module--tag__bloodorange--088d9";
export var tag__chartruse = "tag-module--tag__chartruse--2f6dd";
export var tag__click = "tag-module--tag__click--fe80e";
export var tag__cobalt = "tag-module--tag__cobalt--6b1b5";
export var tag__emerald = "tag-module--tag__emerald--9c272";
export var tag__light = "tag-module--tag__light--282e4";
export var tag__noLink = "tag-module--tag__noLink--3657f";
export var tag__paper = "tag-module--tag__paper--5e459";
export var tag__partner = "tag-module--tag__partner--a02d0";
export var tag__partnerLink = "tag-module--tag__partnerLink--2805c";
export var tag__pink = "tag-module--tag__pink--bc588";
export var tag__sky = "tag-module--tag__sky--a292a";
export var tag__white = "tag-module--tag__white--d1831";